import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  resetStore,
  setSeverityData,
} from "../../../redux/SingleDataset/actions";
import { Outlet } from "react-router";

export const DatasetPageWrapper = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      // when navigating outside pages with path /dataset/:id/<route> - clear store
      dispatch(setSeverityData(null));
      dispatch(resetStore());
    };
  }, [dispatch]);
  return <Outlet />;
};
